
function NewsletterPopupControl() {
    if ($.cookie('NewsletterPopup') != "undefined" && $.cookie('NewsletterPopup') != "false") {
        $.ajax({
            type: 'get',
            async: true,
            cache: false,
            url: "/" + $("#SmallLangCode").val() + "/p/User/UserCheck",
            success: function (dt) {
                console.log(dt);
                if (dt.USER == -1 && $("#SmallLangCode").val() == "tr") {
                    $("#NewsletterPopup").modal();

                }
            }
        });

    }

    //$('#NewsletterPopup').on('hidden.bs.modal', function () {
    //    var expireDate = new Date();
    //    var minutes = 30;
    //    expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);

    //    $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
    //    $(".NewsLetterResult").hide();
    //    $(".NewsletterFormHead").show();
    //})


    $("#IgnoreLink > a,.DialogClose").live("click", function () {

        var expireDate = new Date();
        var minutes = 30;
        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);
        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
        $("#NewsletterPopup").modal("hide");

    });


    $("#newsletterFormSubmit").live("click", function () {
        var expireDate = new Date();
        var minutes = 30;
        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);
        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
    });

}

function HomeCatalogTabs() {
    $("#HomeCatalogTabs .ProductList .Prd").removeClass("col-md-4").removeClass("col-sm-8");
    $("#HomeCatalogTabs .ProductList .Prd").addClass("col-md-6").addClass("col-sm-12");

}

function BasketButtonFixed() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("#Basket").addClass("BasketFixed");

        }
        else {
            $("#Basket").removeClass("BasketFixed");
        }

    });
}

function HeaderFixer() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("header").addClass("fixedHeader");

        }
        else {
            $("header").removeClass("fixedHeader");
        }

    });
}

function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")
    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")
    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }

}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}


function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetTextBannerList",
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }


                }
            }
            settingTextBanner();
        }
    });


}


function RememberCheck() {
    $(".RememberCheck #cbox").on("change", function () {
        if ($(this).prop("checked")) {
            $(".RememberCheck .customCheck").addClass("checked");
        } else {
            $(".RememberCheck .customCheck").removeClass("checked");
        }
    });
}

function HometabSlider() {
    $("#HomeCatalogContens img.img2").remove();
    $("#HomeCatalogContens").slick({
        nextArrow: '<div class="PrdImgRight right-arrow"></div>',
        prevArrow: '<div class="PrdImgLeft left-arrow"></div>',
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
    });
}

$(document).ready(function () {

    //console.log("bundle ready");


    //HomeCatalogTabs();
    //settingTextBanner();
    RememberCheck();
    //HometabSlider();
   // GetLayoutTextBanners();

    if ($(window).width() > 992) {
        // NewsletterPopupControl();
    }
    else {
        $("#NewsletterPopup").modal("hide");
    }

    if ($(".HomeProducts").length > 0) {

        //$(".HomeProducts .Prd").addClass("col-sm-8");
        //$(".HomeProducts .Prd").addClass("col-xs-12");

        $(".HomeProducts div.Prd > a").each(function (index) {

            var imgBG = $(this).find("img:first").attr("src");

            if (imgBG.indexOf("404") != -1 && $(this).find("img:first").attr("data-qazy-src") != undefined) {
                imgBG = $(this).find("img:first").attr("data-qazy-src");
            }

            $(this).css("background-image", "url(" + imgBG + ")");
            $(this).parent().append("<a href='" + $(this).attr("href") + "' class='GotoDetails'>" + $("#GotoDetailsVl").val() + "</a>");

        });
    }

    if (!isMobile(true)) {

        $("#CatalogTabs > li").live({
            mouseenter:
               function () {

                   $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
                   $(this).addClass("active");



                   $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");

               },
            mouseleave:
               function () {


               }
        });

        if ($("#CatalogTabs li[data-id='173']").length > 0) {

            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
            $("#CatalogTabs > li").removeClass("active");

            $("#CatalogTabs li[data-id='173']").addClass("active");
            var index = $("#CatalogTabs li[data-id='173']").index();
            $("#HomeCatalogContens > div").eq(index).addClass("active");

        }


    }

    $("#CatalogTabs li").live("click", function () {

        var href = $("#MainMenu li a[data-rel='" + $("#CatalogTabs li.active").data("id") + "']").attr("href");


        if (!isMobile(true)) {

            if (href != undefined && href != null) {
                document.location.href = href;
            }

        } else if ($(this).hasClass("active")) {

            if (href != undefined && href != null) {
                document.location.href = href;
            }

        }
        else {
            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
            $(this).addClass("active");
            $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");
        }

    });


    //if ($(".HomeProducts").length > 0) {



    //    $(".HomeProducts div.Prd > a").each(function (index) {

    //        var imgBG = $(this).find("img:first").attr("src");

    //        if (imgBG.indexOf("404") != -1 && $(this).find("img:first").attr("data-qazy-src") != undefined) {
    //            imgBG = $(this).find("img:first").attr("data-qazy-src");
    //        }

    //        $(this).css("background-image", "url(" + imgBG + ")");
    //        $(this).parent().append("<a href='" + $(this).attr("href") + "' class='GotoDetails'>" + $("#GotoDetailsVl").val() + "</a>");

    //    });
    //}

    //if (!isMobile(true)) {

    //    $(".HomeCatalogTabs > ul > li").live({
    //        mouseenter:function () {

    //               $(".HomeCatalogTabs ul > li, #HomeCatalogContens > div").removeClass("active");
    //               $(this).addClass("active");

    //               $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");

    //        },
    //        mouseleave:function () {


    //        }

    //    });


       
    //        if ($("#CatalogTabs li[data-id='173']").length > 0) {

    //            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
    //            $("#CatalogTabs > li").removeClass("active");

    //            $("#CatalogTabs li[data-id='173']").addClass("active");
    //            var index = $("#CatalogTabs li[data-id='173']").index();
    //            $("#HomeCatalogContens > div").eq(index).addClass("active");

    //        }
        

    //}



    $("#pieceBanner1, .pieceBannerMiddle1 , .pieceBannerRight1 , .pieceBannerMiddle2 , .pieceBannerRight2 ").live("click", function () {

        var href = $(this).find(".middleText").find("a").first().attr("href");

        if (href != undefined && href != null) {

            document.location.href = href;
        }

    });


    //function GetLastVisitedProducts() {

    //    if ($(".AutoGetLastVisited").length > 0) {

    //        $.ajax({
    //            type: "GET",
    //            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProducts?SpecialTo=true", 
    //            cache: false,
    //            success: function (dt) {

    //                $(".LastViewedProducts.AutoSetted").remove();

    //                if (dt != "") {

    //                    $(".AutoGetLastVisited").append(dt);

    //                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
    //                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
    //                    $(".LastViewedProducts .ProductList .Prd:gt(3)").addClass("hidden-sm");

    //                    if(   $(".LastViewedProducts .ProductList .Prd").length >= 6)
    //                    {
    //                        $(".AutoGetLastVisited").show();
    //                    }

    //                }

    //            }
    //        });
    //    }
    //}

    //GetLastVisitedProducts();

    //homebannerFull2



});